export default "__VITE_ASSET__1339229a__"